import axios from "axios";

const baseURL = "/api/cdk/service-view/v1";

const URL = {
  listStores: `${baseURL}/list/stores`,
  serviceView: `${baseURL}/service-view`
};

const HEADERS = {
  "Content-Type": "application/json"
};

const ServiceViewService = {
  getServiceViewConfigs: async () => {
    const response = await axios.get(`${URL.serviceView}/`, {
      headers: HEADERS
    });
    return response.data;
  },
  createServiceViewConfig: async config => {
    const response = await axios.post(`${URL.serviceView}`, config, {
      headers: HEADERS
    });
    return response.data;
  },
  updateServiceViewConfig: async config => {
    const response = await axios.put(`${URL.serviceView}`, config, {
      headers: HEADERS
    });
    return response.data;
  },
  deleteServiceViewConfig: async mappingId => {
    const response = await axios.delete(
      `${URL.serviceView}/mappingid/${mappingId}`,
      { headers: HEADERS }
    );
    return response.data;
  }
};

export default ServiceViewService;
